import { RequestStatus } from '../../types/api/order-request'
import { ReceiptStatus } from '../../types/api/receipt'

export const orderRequestStatus: RequestStatus[] = ['Отменен', 'Новый', 'Обработан']
export const receiptsStatus: ReceiptStatus[] = ['Создан', 'Прибыл', 'В приемке', 'Завершен']
